module.exports = __webpack_public_path__ + "static/media/dripicons-v2.cf09c981.ttf";